import React from 'react';
import 'react-dual-listbox/lib/react-dual-listbox.css';
import 'font-awesome/css/font-awesome.min.css';
import DualListBox from 'react-dual-listbox';
import { enqueueSnackbar, closeSnackbar } from 'notistack';
import { IconButton } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

import usePostDevicesToWarehouse from 'hooks/Traps/DeviceWarehouse/usePostDeviceToWarehopuse';
import { PostDevicesToWarehouseRequest } from 'api/traps/DevicesWareHouse/types';

interface Step2Props {
  traps: { id: number; serial_number: string; device_type: string }[];
  selectedTraps: PostDevicesToWarehouseRequest;
  setSelectedTraps: React.Dispatch<React.SetStateAction<PostDevicesToWarehouseRequest>>;
  onReset: () => void;
  token: string;
}

interface Option {
  value: string;
  label: string;
}

interface Group {
  label: string;
  options: Option[];
}

const ChooseTrapsStep: React.FC<Step2Props> = ({ traps, selectedTraps, setSelectedTraps, onReset, token }) => {
  const { addDeviceToWarehouse } = usePostDevicesToWarehouse();
  const trapOptions: Group[] = traps.reduce<Group[]>((acc, trap) => {
    const group = acc.find(g => g.label === trap.device_type);

    if (group) {
      group.options.push({
        value: trap.id.toString(),
        label: trap.serial_number,
      });
    } else {
      acc.push({
        label: trap.device_type,
        options: [
          {
            value: trap.id.toString(),
            label: trap.serial_number,
          },
        ],
      });
    }

    return acc;
  }, []);

  const handleSelection = (selected: string[]) => {
    const newTrapIds: number[] = [];
    const newHubIds: number[] = [];

    selected.forEach(idString => {
      const id = parseInt(idString, 10);

      const device = traps.find(trap => trap.id === id);

      if (device) {
        if (device.device_type.toLowerCase() === 'hub') {
          newHubIds.push(id);
        } else {
          newTrapIds.push(id);
        }
      }
    });

    setSelectedTraps({
      trap_ids: newTrapIds,
      hub_ids: newHubIds,
      token: token,
    });
  };
  const hundleSubmit = () =>
    addDeviceToWarehouse(selectedTraps, {
      onSuccess: () => {
        onReset();
        enqueueSnackbar('Device(s) added successfully', {
          variant: 'success',
          action: key => (
            <IconButton onClick={() => closeSnackbar(key)} color="inherit">
              <CloseIcon />
            </IconButton>
          ),
        });
      },
    });

  return (
    <div>
      <h5 className="text-center mb-3">Step 2: Select devices</h5>
      <h6 className="text-center mb-3 text-muted">to be moved to your company's inventory.</h6>
      <DualListBox
        options={trapOptions}
        selected={[
          ...(selectedTraps.trap_ids?.map(id => id.toString()) || []),
          ...(selectedTraps.hub_ids?.map(id => id.toString()) || []),
        ]}
        onChange={handleSelection}
        canFilter
        filterPlaceholder="Search for traps..."
        icons={{
          moveLeft: <i className="fa fa-chevron-left" />,
          moveAllLeft: [
            <span key={0} className="fa fa-chevron-left" />,
            <span key={1} className="fa fa-chevron-left" />,
          ],
          moveRight: <span className="fa fa-chevron-right" />,
          moveAllRight: [
            <span key={0} className="fa fa-chevron-right" />,
            <span key={1} className="fa fa-chevron-right" />,
          ],
        }}
      />
      <div className="d-flex my-2 justify-content-between">
        <h6 className="text-muted">Purchased devices</h6>
        <h6 className="text-muted">Inventory</h6>
      </div>
      <div className="d-flex justify-content-end mt-3">
        <button
          className="btn btn-ghost-success waves-effect waves-light"
          onClick={hundleSubmit}
          disabled={selectedTraps.trap_ids?.length === 0 && selectedTraps.hub_ids?.length === 0}
        >
          Submit
        </button>
      </div>
    </div>
  );
};

export default ChooseTrapsStep;
